import React from 'react';
import { useParams } from 'react-router';
import { apiUrl } from 'utils/apiUrl';
import { useTranslation } from 'react-i18next';
import { ExecutionDetailsView } from 'components/JobExecution/ExecutionDetailsView';

const CHILD_JOBS_LIMIT = 500;

export const GlobalJobExecutionDetails: React.FC = () => {
  const { t } = useTranslation();
  const { executionId } = useParams<{ executionId: string }>();
  return (
    <ExecutionDetailsView
      apiPath={apiUrl(
        'lct',
        `tenants/global/jobManager/executions/${executionId}?limit=${CHILD_JOBS_LIMIT}`,
      )}
      title={t('jobService.executionDetail')}
      testIdPrefix="global-job-execution"
    />
  );
};

export default GlobalJobExecutionDetails;
